import { makeStyles } from '@material-ui/core'
import LegendIcon from 'components/CopilotControl/icons/LegendIcon'
import React from 'react'

const useStyles = makeStyles(() => ({
  root: {
    margin: '2px 3px',
    height: 37,
    borderRadius: 10,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 8,
    padding: '0 12px',
    cursor: 'pointer',
    fontFamily: 'Dazzed',
    fontSize: 14,
    fontWeight: 500,
    '&:disabled': {
      cursor: 'default'
    }
  },
  legend: {
    display: 'flex'
  },
  countField: {
    fontWeight: 600
  }
}))

const OralHygieneCategoryChip = ({ label, count, color, selected = false, disabled = false, onClick }) => {
  const classes = useStyles()

  return (
    <button
      type="button"
      className={classes.root}
      disabled={disabled}
      aria-pressed={selected}
      style={{
        opacity: disabled ? 0.4 : 1,
        backgroundColor: selected ? '#7E8DF3' : disabled ? '#F6F6F6' : '#E7EAFF',
        color: selected ? '#FFFFFF' : '#001335',
        border: selected ? '2px solid #3C52EF' : '2px solid transparent'
      }}
      onClick={onClick}
    >
      {color && (
        <span className={classes.legend}>
          <LegendIcon color={color} />
        </span>
      )}
      <span>{label}</span>
      {count !== undefined && <span className={classes.countField}>{count}</span>}
    </button>
  )
}

export default OralHygieneCategoryChip
